// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"637":"28d41b7e","989":"98f6e4e3"}[chunkId] + ".chunk.css";
};